import img1 from './assets/images/header/img1.png';
import img2 from './assets/images/header/img2.png';
import img3 from './assets/images/header/img3.png';
import img4 from './assets/images/header/img4.png';
import img5 from './assets/images/header/img5.png';
import img6 from './assets/images/header/img6.png';
import img7 from './assets/images/header/img7.png';
import img8 from './assets/images/header/img8.png';
import img9 from './assets/images/header/img9.png';
import img10 from './assets/images/header/img10.png';
import { FixIDS } from './utils/fixIDS';


const HeaderNav = [
  {
    path: "/dashboard",
    name: "Dashboard\n& Analytics",
    img: img1,
    permission_ids: [FixIDS.Dashboard_And_Analytics.List],
  },
  {
    path: "/sample-management",
    name: "Sample\nManagement",
    img: img2,
    permission_ids: [FixIDS.Sample_management.List],
  },
  {
    path: "/instrument-management",
    name: "Instrument\nManagement",
    img: img3,
    permission_ids: [FixIDS.Instrument_management.List],
  },
  {
    path: "/certificate-generation",
    name: "Certificate\nGeneration",
    img: img4,
    permission_ids: [FixIDS.Certification_generation.List],
    
  },
  {
    path: "/customer-management",
    name: "Customer\nManagement",
    img: img5,
    permission_ids: [FixIDS.Customer_management.List],
  },
  {
    path: "/quality-management/general-requirement/imperiality",
    name: "Quality Management\n(QMS)",
    img: img6,
    permission_ids: [FixIDS.Quality_management.List],
      activeBase: "/quality-management"
  },
{
  path: "/reports-generation/sample-report", //default page
  name: "Reports\nGeneration",
  img: img7,
  permission_ids: [FixIDS.Report_genration.List],
  activeBase: "/reports-generation"
},
  {
    path: "/user-management/roles",
    name: "User\nManagement",
    img: img9,
    permission_ids: [FixIDS.User_management.List],
     activeBase: "/user-management"
  },
  {
    path: "/audit-traceability-logs",
    name: "Audit & Traceability\nLogs",
    img: img8,
    permission_ids: [FixIDS.Audit_and_traceability.List],
  },
  
  {
    path: "/security-compliance",
    name: "Security &\nCompliance",
    img: img10,
    permission_ids: [FixIDS.Security_and_compliance.List],
  },
];


export default HeaderNav; 
